import React from 'react';
import classNames from 'clsx';

import styles from './StickyContainer.module.scss';

type Props = {
  offsetTop?: number;
  className?: string;
  children: React.ReactNode;
};

function StickyContainer({ offsetTop = 0, children, className = '', ...props }: Props) {
  return (
    <div
      {...props}
      className={classNames(styles.Wrapper, className)}
      style={{
        top: offsetTop,
      }}
    >
      {children}
    </div>
  );
}

export default StickyContainer;
